const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})()
// Swatches without an image (all_products only resolves 20 products per page) get the product's
// first image here. Also runs for cards added later, e.g. by "Load more" or filtering.
const swatchImageRequests = {};

const fillSwatchImages = () => {
  document.querySelectorAll('[data-swatch-fallback]:empty').forEach((swatch) => {
    const handle = swatch.dataset.swatchFallback;
    if (!handle) return;

    swatchImageRequests[handle] = swatchImageRequests[handle] || fetch(`${window.Shopify.routes.root}products/${handle}.js`)
      .then((response) => response.json())
      .catch(() => null);

    swatchImageRequests[handle].then((product) => {
      if (!product || !product.images || !product.images[0] || swatch.childElementCount) return;

      const image = new Image(50, 50);
      image.loading = 'lazy';
      image.src = product.images[0].replace(/(\.[^/.?]+)(\?|$)/, '_160x$1$2');
      image.alt = product.title;
      swatch.title = product.title;
      swatch.appendChild(image);

      const link = swatch.closest('a');
      if (link) link.dataset.cardImage = product.images[0].replace(/(\.[^/.?]+)(\?|$)/, '_720x$1$2');
    });
  });
};

fillSwatchImages();
new MutationObserver(fillSwatchImages).observe(document.body, { childList: true, subtree: true });

// Hovering a color swatch shows that color in the card image; leaving the swatches restores the original.
const restoreCardImage = (card) => {
  card.classList.remove('card-wrapper--swatch-preview');
  const image = card.querySelector('.media--first');
  if (!image || !image.dataset.originalSrc) return;

  image.src = image.dataset.originalSrc;
  image.srcset = image.dataset.originalSrcset || '';
};

document.addEventListener('mouseover', (event) => {
  const swatch = event.target.closest('.card-wrapper .color-picker a[data-card-image], .card-wrapper .color-picker .swatch-container.active');
  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');
  const image = card && card.querySelector('.media--first');
  if (!image) return;

  if (!image.dataset.originalSrc) {
    image.dataset.originalSrc = image.src;
    image.dataset.originalSrcset = image.getAttribute('srcset') || '';
  }

  if (swatch.matches('.swatch-container.active')) {
    restoreCardImage(card);
    return;
  }

  image.srcset = '';
  image.src = swatch.dataset.cardImage;
  // Keep the "second image on hover" hidden, otherwise it covers the previewed color
  card.classList.add('card-wrapper--swatch-preview');
});

document.addEventListener('mouseout', (event) => {
  const picker = event.target.closest('.card-wrapper .color-picker');
  if (!picker || picker.contains(event.relatedTarget)) return;

  restoreCardImage(picker.closest('.card-wrapper'));
});

// Safari only starts loading lazy images when they are almost on screen, so when scrolling quickly the cards show empty
// for a moment. Start loading the images of cards about one and a half screens before they come into view
// (not the second image, that one only shows on hover).
const preloadCardImages = (() => {
  if (!('IntersectionObserver' in window)) return () => {};

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.loading = 'eager';
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px 150% 0px' });

  return () => {
    document.querySelectorAll('.card-wrapper img[loading="lazy"]:not(.media--second):not([data-preload-observed])').forEach((image) => {
      image.dataset.preloadObserved = '';
      observer.observe(image);
    });
  };
})();

preloadCardImages();
// Cards added later (Load more, filtering) are picked up as well
new MutationObserver(preloadCardImages).observe(document.body, { childList: true, subtree: true });
